import { render, staticRenderFns } from "./AddEditSpeaker.vue?vue&type=template&id=b175a254"
import script from "./AddEditSpeaker.vue?vue&type=script&lang=js"
export * from "./AddEditSpeaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports